import { render, staticRenderFns } from "./Receive.vue?vue&type=template&id=b298503e"
import script from "./Receive.vue?vue&type=script&lang=js"
export * from "./Receive.vue?vue&type=script&lang=js"
import style0 from "./Receive.vue?vue&type=style&index=0&id=b298503e&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports